import {
  Component,
  Input,
  AfterViewInit,
  ElementRef,
  HostBinding
} from '@angular/core';
import { ADS_ENABLED, AD_DEBUG_OUTLINE } from 'src/app/constants/ads.config';

@Component({
  selector: 'app-native-ad',
  template: `
    <div
      [id]="containerId"
      style="width:100%; margin:1rem auto;"
      [style.min-height.px]="debugOutline ? 40 : null"
    ></div>
    <!-- Off in every deployed build; see AD_DEBUG_OUTLINE in ads.config -->
    <small *ngIf="debugOutline" class="ad-debug-tag">native (mobile only)</small>
  `,
  styles: [`
    .ad-debug-tag {
      display: block; text-align: center; font: 11px/1.4 monospace;
      color: #2e7d32; letter-spacing: .04em;
    }
  `]
})
export class NativeAdComponent implements AfterViewInit {

  @Input() containerId!: string;
  @Input() scriptSrc!: string;

  /** Debug affordance, off in every deployed build. See AD_DEBUG_OUTLINE. */
  readonly debugOutline = AD_DEBUG_OUTLINE;
  @HostBinding('style.outline') get debugBorder(): string {
    return AD_DEBUG_OUTLINE ? '2px dashed #2e7d32' : '';
  }

  // Collapse the host element when ads are globally disabled (see ads.config).
  // While debugging, force a block box so the outline wraps the slot, not the line box.
  @HostBinding('style.display') get hostDisplay(): string {
    if (!ADS_ENABLED) { return 'none'; }
    return AD_DEBUG_OUTLINE ? 'block' : '';
  }

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (!ADS_ENABLED) { return; }
    const script = document.createElement('script');
    script.src = this.scriptSrc;
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    this.el.nativeElement.appendChild(script);
  }
}
